import React from 'react';
import SharingSetupModal from '../SharingSetupModal';
import type { SharingSetupProps } from '../types';
import { rallyInjectableFields } from './injectableFields';
import defaultShareFormYaml from './default_share_form.yaml?raw';

/**
 * Rally share-message form editor: the shared shell seeded with the rally
 * form.
 */
const SharingSetup: React.FC<SharingSetupProps> = props => (
  <SharingSetupModal
    {...props}
    defaultShareFormYaml={defaultShareFormYaml}
    injectableFields={rallyInjectableFields}
  />
);

export default SharingSetup;
